import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/constants';
import churchDashboardService from '@/services/church-dashboard.service';

type RejectNotificationVariables = {
  churchId: string;
  id: string;
};

export const useRejectNotificationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ churchId, id }: RejectNotificationVariables) =>
      churchDashboardService.rejectNotification({ churchId, id }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.DASHBOARD_NOTIFICATIONS] });
    },
  });
};
